import NotificationBar from './NotificationBar';

export default NotificationBar;



// WEBPACK FOOTER //
// ./src/components/NotificationBar/index.js